import React from 'react';
import { Link } from 'react-router-dom';
import { FooterProps } from '../../types';

export const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`bg-gray-900 text-gray-400 py-12 border-t border-gray-800 ${className}`}>
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">About</h3>
            <p className="text-sm leading-relaxed">
              The Definitive D8 Directory provides comprehensive, research-backed rankings of 47 authenticated Delta-8 THC and hemp flower vendors based on analysis of 260+ sources.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-green-400 transition-colors duration-300">
                  Vendor Directory
                </Link>
              </li>
              <li>
                <Link to="/editor" className="hover:text-green-400 transition-colors duration-300">
                  Research Report
                </Link>
              </li>
              <li>
                <a href="#directory" className="hover:text-green-400 transition-colors duration-300">
                  Browse Vendors
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Resources */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Legal & Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="hover:text-green-400 transition-colors duration-300">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-green-400 transition-colors duration-300">
                  Terms & Data Collection
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-green-400 transition-colors duration-300">
                  FAQ
                </Link>
              </li>
              <li>
                <a
                  href="/llm.txt"
                  className="hover:text-green-400 transition-colors duration-300"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LLM.txt
                </a>
              </li>
              <li>
                <a
                  href="/robots.txt"
                  className="hover:text-green-400 transition-colors duration-300"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Robots.txt
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 text-center text-sm">
          <p className="mb-2">
            &copy; {currentYear} The Definitive D8 Directory. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mb-2">
            Contact: <a href="mailto:leverage_labs_alpha@proton.me" className="hover:text-green-400 transition-colors">leverage_labs_alpha@proton.me</a>
          </p>
          <p className="text-gray-600 text-xs">
            All research data is for informational purposes only. Consult local laws before purchasing.
          </p>
        </div>
      </div>
    </footer>
  );
};
